import { render, staticRenderFns } from "./NavInfo.vue?vue&type=template&id=c239c7c6&scoped=true&"
import script from "./NavInfo.vue?vue&type=script&lang=js&"
export * from "./NavInfo.vue?vue&type=script&lang=js&"
import style0 from "./NavInfo.vue?vue&type=style&index=0&id=c239c7c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c239c7c6",
  null
  
)

export default component.exports